"use client";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { RefObject } from "react";

if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger);
}
export const useTextReveal = (
  scopeRef: RefObject<HTMLElement | null>,
  selector: string,
  isEnabled: boolean = true,
) => {
  useGSAP(
    () => {
      if (!isEnabled) return;
      const cards = gsap.utils.toArray<HTMLElement>(selector);
      cards.forEach((card) => {
        const chars = card.querySelectorAll(".reveal-char");
        gsap.to(chars, {
          opacity: 1,
          stagger: 0.05,
          scrollTrigger: {
            trigger: card,
            start: "top 80%",
            end: "top 30%",
            scrub: true,
          },
        });
      });
    },
    { scope: scopeRef, dependencies: [isEnabled] },
  );
};
